<template>
  <div class="network-data"></div>
</template>

<script>
export default {
  name: 'NetworkData',
};
</script>

<style lang="sass" scoped>
.network-data
  &__field-tooltip
      ::v-deep .info-badge__icon
        color: var(--font-color-primary)

  &__info-title
    font-size: 0.9em
    font-weight: bold
    margin: 0 0 5px 0

  &__form-field
    margin: 5px 0 15px 0

    &-last-notif-check
      margin: 5px 0 1rem

  &__info-alert
    border-color: var(--color-info)

    p
      margin-bottom: 0
</style>
